var _filter, _rect, _g, _g2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeylogger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0a0e27",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1f3a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "keyGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ff88",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00cc66",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#bgGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 120,
    width: 300,
    height: 140,
    rx: 8,
    fill: "none",
    stroke: "#00ff88",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "keys",
    stroke: "#00ff88",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 135,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 160,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 185,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 210,
    width: 18,
    height: 18,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 160,
    width: 18,
    height: 18,
    rx: 2,
    fill: "url(#keyGradient)",
    stroke: "#00ff88",
    strokeWidth: 2,
    opacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "dataStream",
    opacity: 0.7,
    fill: "none",
    stroke: "#00ff88",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 200 80 Q 200 100, 210 110",
    strokeDasharray: "2,3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200 75 Q 200 95, 195 105",
    strokeDasharray: "2,3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200 85 Q 200 105, 215 115",
    strokeDasharray: "2,3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "signals",
    stroke: "#00ff88",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30 60 Q 35 55, 40 60 T 50 60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30 70 Q 35 65, 40 70 T 50 70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30 80 Q 35 75, 40 80 T 50 80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(200, 50)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -5,
    width: 30,
    height: 25,
    rx: 3,
    fill: "none",
    stroke: "#ff0055",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 -5 Q -10 -20, 10 -20 Q 10 -5, 10 -5",
    fill: "none",
    stroke: "#ff0055",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 5,
    r: 3,
    fill: "none",
    stroke: "#ff0055",
    strokeWidth: 1.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fontFamily: "monospace",
    fontSize: 10,
    fill: "#00ff88"
  }, /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 260
  }, "01101011"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 280
  }, "11001001"), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 265
  }, "10101010"), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 280
  }, "01001011"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 30,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#00ff88",
    textAnchor: "middle",
    opacity: 0.9
  }, "KEYLOGGER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeylogger);
export default __webpack_public_path__ + "static/media/Keylogger.9c4791e0b88c25f0f927291b81cc7260.svg";
export { ForwardRef as ReactComponent };